module.exports = __webpack_public_path__ + "img/add_tx.89f3dcbb.svg";